<template>
  <v-container class="product-info-part1 pa-0" fluid>


    <v-row class="semanticsection-title2 header" no-gutters>
      <v-col cols="12" md="6" class="primary--text">Privatkunden Produktübersicht
      </v-col>
      <a :href="getLink(0)"
         target="_blank"
         class="link">
        <span>{{ getLinkText(0) }}</span>
        <v-icon class="ml-1" size="16px">open_in_new</v-icon>
      </a>
    </v-row>

    <product-info-table id="product-table" class="mt-n4" />

    <v-divider id="prodTableDivider" class="bg-dimmeddark" />

    <v-row no-gutters class="semanticsection-title2">
        <v-col cols="12" md="6" class="primary--text">Standard
        </v-col>
        <a :href="hls.standard.link"
           target="_blank"
           class="link">
          <span>{{ hls.standard.title }}</span>
          <v-icon class="icon"
                  size="16px">open_in_new
          </v-icon>
        </a>
      <v-col cols="12" md="6"/>
      <a :href="pibs.standard.link"
         target="_blank"
         class="link">
        <span>{{ pibs.standard.title }}</span>
        <v-icon size="16px">open_in_new
        </v-icon>
      </a>
    </v-row>

    <product-info-line>Leistungsstarker Rechtsschutz zu attraktiven Beiträgen</product-info-line>
    <product-info-line>Deckungsschutz auch nach Ablauf der Nachhaftungspflicht des Vorversicherers</product-info-line>
    <product-info-line>Beitragsreduzierung um 50 % bei Arbeitslosigkeit</product-info-line>
    <product-info-line>Schadenfreiheits-Beratungsbonus nach drei schadenfreien Jahren</product-info-line>

    <v-divider class="bg-dimmeddark" />

    <v-row no-gutters class="semanticsection-title2">
      <v-col cols="12" md="6" class="primary--text">EXPERT
      </v-col>
      <a :href="hls.expert.link"
         target="_blank"
         class="link">
        <span>{{ hls.expert.title }}</span>
        <v-icon class="icon"
                size="16px">open_in_new
        </v-icon>
      </a>
      <v-col cols="12" md="6"/>
      <a :href="pibs.expert.link"
         target="_blank"
         class="link">
        <span>{{ pibs.expert.title }}</span>
        <v-icon size="16px">open_in_new
        </v-icon>
      </a>
    </v-row>

     <product-info-line>Steuer-Rechtsschutz bereits im Einspruchsverfahren, Kostenübernahme bis 2.500 €</product-info-line>
     <product-info-line>Sozial-Rechtsschutz bereits im Widerspruchsverfahren</product-info-line>
     <product-info-line>Verwaltungs-Rechtsschutz bereits im Widerspruchsverfahren, Kostenübernahme bis 1.000 €</product-info-line>
     <product-info-line>Erweiterter Beratungs-Rechtsschutz im Familien-, Lebenspartnerschafts- und Erbrecht, Kostenübernahme bis 2.500 €</product-info-line>
     <product-info-line>Rechtsschutz bei bestimmten Kapitalanlagegeschäften: Kostenübernahme bis 20.000 €</product-info-line>
     <product-info-line>Beitragsbefreiung bei Arbeitslosigkeit bis zu einem Jahr</product-info-line>
     <product-info-line>Mitversichert im Verkehrs-Rechtsschutz: Fahrzeuge der volljährigen Kinder in Ausbildung</product-info-line>
     <product-info-line>Rechtsschutz bei Park- und Halteverstößen, bei denen Punkte drohen</product-info-line>
     <product-info-line>Mitversichert im Wohnungs-Rechtsschutz: Zwei selbstgenutzte Wohnungen in Deutschland</product-info-line>
     <product-info-line>u.v.m</product-info-line>

    <v-divider class="bg-dimmeddark" />

    <v-row no-gutters class="semanticsection-title2">
      <v-col cols="12" md="6" class="primary--text">PRESTIGE
      </v-col>
      <a :href="hls.prestige.link"
         target="_blank"
         class="link">
        <span>{{ hls.prestige.title }}</span>
        <v-icon class="icon"
                size="16px">open_in_new
        </v-icon>
      </a>
      <v-col cols="12" md="6"/>
      <a :href="pibs.prestige.link"
         target="_blank"
         class="link">
        <span>{{ pibs.prestige.title }}</span>
        <v-icon size="16px">open_in_new
        </v-icon>
      </a>
    </v-row>

    <product-info-line>Verwaltungs-Rechtsschutz bereits im Widerspruchsverfahren</product-info-line>
    <product-info-line>Steuer-Rechtsschutz bereits im Einspruchsverfahren, Kostenübernahme bis 5.000 €</product-info-line>
    <product-info-line>Rechtsschutz für gerichtliches Betreuungsverfahren, Kostenübernahme bis 3.500 €</product-info-line>
    <product-info-line>Erweiterter Beratungs-Rechtsschutz im Familien-, Lebenspartnerschafts- und Erbrecht, Kostenübernahme bis 5.000 €</product-info-line>
    <product-info-line>Arbeits-Rechtsschutz auch bei Aufhebungsvereinbarungen, Kostenübernahme bis 2.500 €</product-info-line>
    <product-info-line>Mitversichert im Wohnungs-Rechtsschutz: Alle in Deutschland selbstgenutzten Wohneinheiten</product-info-line>
    <product-info-line>u.v.m.</product-info-line>

    <div class="bg-dimmed schnellsicher">

      <div id="sus-fixed-box" class="bg-dimmed">&nbsp;</div>

      <div id="sus-content">

        <v-row no-gutters class="semanticsection-title2">
          <v-col cols="12" md="6" class="primary--text">Schnell & Sicher
          </v-col>
          <a :href="hls.sus.link"
             target="_blank"
             class="link">
            <span>{{ hls.sus.title }}</span>
            <v-icon size="16px">open_in_new
            </v-icon>
          </a>
          <v-col cols="12" md="6"/>
          <a :href="pibs.sus.link"
             target="_blank"
             class="link">
            <span>{{ pibs.sus.title }}</span>
            <v-icon size="16px">open_in_new
            </v-icon>
          </a>
        </v-row>

        <product-info-line line-icon="star">
          Das Rechtsschutz-Paket für Privat, Beruf, Verkehr, Wohnung
        </product-info-line>
        <product-info-line line-icon="star">
          Inklusive dem weitreichenden Spezial-Straf-Rechtsschutz
        </product-info-line>
        <product-info-line line-icon="star">
          300 € Selbstbeteiligung
        </product-info-line>
        <product-info-line line-icon="star">
          Nach 3 schadenfreien Jahren: 0 € Selbstbeteiligung
        </product-info-line>
        <product-info-line line-icon="star">
          Schadenfreie Jahre beim Vorversicherer werden angerechnet
        </product-info-line>
        <product-info-line line-icon="star">
          1 Jahr Laufzeit
        </product-info-line>
        <product-info-line line-icon="star">
          Einfach, schnell und haftungssicher
        </product-info-line>

      </div>

    </div>

    <div class="yolig bg-dimmed">

      <div id="yolig-fixed-box" class="bg-dimmed">&nbsp;</div>

      <div id="yolig-content">

        <v-row no-gutters class="semanticsection-title2">
          <v-col cols="12" md="6" class="primary--text">YOLIG
          </v-col>
          <a :href="hls.yolig.link"
             target="_blank"
             class="link">
            <span>Highlightblatt YOLIG</span>
            <v-icon size="16px">open_in_new
            </v-icon>
          </a>
          <v-col cols="12" md="6"/>
          <a :href="pibs.yolig.link"
             target="_blank"
             class="link">
            <span>Produktinformationen YOLIG</span>
            <v-icon size="16px">open_in_new
            </v-icon>
          </a>
        </v-row>

        <product-info-line line-icon="yolig">
          Umfassender Rechtsschutz für ein zukunftsbewusstes Leben
        </product-info-line>
        <product-info-line line-icon="yolig">
          Mit besonderen Nachhaltigkeitsfaktoren
        </product-info-line>
        <product-info-line line-icon="yolig">
          Mobilitäts-Rechtsschutz auch ohne Verkehrs-Rechtsschutz, z. B. für Nutzer
          von Car-Sharing, Fahrgast im öffentlichen Bus- und Bahnverkehr, Fahrer von E-Bikes
        </product-info-line>
        <product-info-line line-icon="yolig">
          Fahrzeug mit Elektro- oder alternativem Antrieb: Günstiger Beitrag im Verkehrs-Rechtsschutz
        </product-info-line>
        <product-info-line line-icon="yolig">
          Rechtsschutz für Solar-, Photovoltaik-, Windenergieanlagen,
          Kostenübernahme bis 15.000 Euro, auch für die Einspeisung ins öffentliche Stromnetz
        </product-info-line>
        <product-info-line line-icon="yolig">
          Klimafreundliche Bearbeitung
        </product-info-line>
        <product-info-line line-icon="yolig">
          Jeder YOLIG-Vertrag unterstützt ein Umwelt- und Klimaschutzprojekt: Durch
          Spenden für jedes Versicherungsjahr und zusätzlich bei Schadenfreiheit
        </product-info-line>
        <product-info-line line-icon="yolig">
          u.v.m.
        </product-info-line>
      </div>

    </div>

  </v-container>
</template>

<script>
import ProductInfoTable from "@/components/productInfo/ProductInfoTable.vue";
import ProductInfoLine from "@/components/productInfo/ProductInfoLine";
import BrowserDetectionMixin from "@/components/helper/BrowserDetectionMixin";
export default {
  name: "ProductInfoPart1",
  components: { ProductInfoTable, ProductInfoLine },
  mixins: [BrowserDetectionMixin],
  props: {
    linkinfos: {
      type: Array,
      required: true
    },
    pibs: {
      type: Object,
      required: true
    },
    hls: {
      type: Object,
      required: true
    }
  },
  methods:{
    getLink(index){
      return this.linkinfos[index].link;
    },
    getLinkText(index){
      return this.linkinfos[index].title;
    }
  }
};
</script>
<style>

.product-info-part1 .semanticsection-title2 {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  background-color: transparent;
}

.product-info-part1 #product-table {
  width: 100%;
}

.product-info-part1 #prodTableDivider {
  margin-top: 80px;
  width: 1184px;
  min-width: 1184px;
  margin-left: calc(-1 * (1184px - 100%) / 2);
}

.product-info-part1 .product-info-line:last-child .product-line {
  margin-bottom: 0!important;
}

.product-info-part1 .divider {
  margin-top: 56px;
}

.product-info-part1 .link .v-icon {
  text-decoration: none !important;
  color: #002C76;
  padding-bottom: 3px;
}

.product-info-part1 a:hover.link .v-icon {
  color: #0085CF;
}

.product-info-part1 a:hover span {
  text-decoration: underline !important;
  color: #0085CF;
}

.product-info-part1 .link{
  color: #002C76 !important;
  font-size: 16px;
}

.product-info-part1 .schnellsicher {
  position: relative;
  margin: 56px 0;
}

.product-info-part1 .schnellsicher #sus-fixed-box {
  position: absolute;
  z-index: 0;
  top: 0;
  height: 100%;
  width: 100vw;
  margin-left: calc(-1* (100vw - 100%)/2);
}

.product-info-part1 .schnellsicher #sus-content {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 40px 0;
}

.product-info-part1 .schnellsicher .semanticsection-title2 {
  margin: 0!important;
  padding: 0 0 40px 0!important;
}

.product-info-part1 .yolig {
  position: relative;
  margin: 56px 0;
}

.product-info-part1 .yolig #yolig-fixed-box {
  position: absolute;
  z-index: 0;
  top: 0;
  height: 100%;
  width: 100vw;
  margin-left: calc(-1* (100vw - 100%)/2);
}

.product-info-part1 .yolig #yolig-content {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 40px 0;
}

.product-info-part1 .yolig .semanticsection-title2 {
  margin: 0!important;
  padding: 0 0 40px 0!important;
}

.sticky-box {
  position: sticky;
  position: -webkit-sticky;

}

.fixed-box {
  top: 136px !important;
  width: 100%;
  z-index: 6;
  margin: 0;
}

@media screen and (max-width: 1100px) , screen and (max-height: 800px) {
  .fixed-box {
    top: 92px !important;
  }
}
</style>
